<div class="px-3 py-2 bg-neutral-900/[.30] rounded-lg text-xs">
  <div
    [ngClass]="{ 'border-b-[0.5px] border-b-neutral-700 pb-[6px] mb-[6px]': showMore }"
    class="flex justify-between leading-[22px]"
  >
    <div>
      @if (added().length) {
        <span class="text-green-300 font-bold">{{ added().length }} added</span>
      }
      @if (added().length && removed().length) {
        <span>; </span>
      }
      @if (removed().length) {
        <span class="text-red-300 font-bold">{{ removed().length }} removed</span>
      }
    </div>

    <button
      (click)="showMore = !showMore"
      class="font-semibold cursor-pointer select-none"
    >
      {{ showMore ? 'Less' : 'More' }}
    </button>
  </div>

  @if (showMore) {
    <div class="flex flex-col gap-[2px]">
      @for (addedEntity of addedWithDisplayMetadata(); track addedEntity.id) {
        <ng-container
          *ngTemplateOutlet="summaryItem; context: { entity: addedEntity, isAdded: true }"
        ></ng-container>
      }
      @for (removedEntity of removedWithDisplayMetadata(); track removedEntity.id) {
        <ng-container
          *ngTemplateOutlet="summaryItem; context: { entity: removedEntity, isAdded: false }"
        ></ng-container>
      }
    </div>
  }
</div>

<ng-template
  #summaryItem
  let-entity="entity"
  let-isAdded="isAdded"
>
  <div class="flex gap-1 leading-[18px] items-center even:bg-white/[.05]">
    <span
      [ngClass]="[isAdded ? 'text-green-300' : 'text-red-300']"
      class="w-16 font-bold text-green-300 shrink-0"
      >{{ isAdded ? '[Added]' : '[Removed]' }}</span
    >
    <div
      [innerHTML]="nodeIconByType[entity.type]"
      class="flex items-center w-4 *:w-4 h-4 *:h-4 *:text-white *:fill-white"
    ></div>
    <span [class.italic]="entity.italic">{{ entity.name }}</span>
  </div>
</ng-template>
